<mat-card>
  <mat-card-content>
    <span>{{ 'page.notFound.description' | translate }}</span>
  </mat-card-content>
</mat-card>
